// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/home/jenkins/agent/workspace/web-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from '/home/jenkins/agent/workspace/web-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import CrownOutlined from '/home/jenkins/agent/workspace/web-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
export default { SmileOutlined, UserOutlined, CrownOutlined };
